import { ActionTypes as action } from "./action-types";
import { initialState } from './state';

const mutations = {
    [action.GET_SEARCH_RESULT](state, data) {
        if (state.searchResult.length && data.length === 1) {
            const result = state.searchResult.find((s) => s.origin === data[0].origin)
            if (result) {
                // result.value = result.value.concat(data[0].value)
                data[0].value.map(d => {
                    let isExist = result.value.every(res => d.id !== res.id);
                    if(isExist) {
                        result.value.push(d);
                    }
                });
            } else {
                state.searchResult.push(data[0])
            }
        } else {
            state.searchResult = data;
        }
    },
    [action.SET_SEARCH_TEXT](state, text) {
        state.searchText = text;
    },
    [action.SET_LOADER](state, isLoading) {
        state.loaderLoading = isLoading;
    },
    [action.RESET_STATE](state) {
        Object.assign(state, initialState);
    },
    [action.SET_DOCUMENT_HEADERS](state, data) {
        state.documentSearchHeaders = data;
    },
};

export default mutations;
